import React, { useEffect, useState } from "react";
import ViewPreDefinedIndex from "../../../../components/View/ViewPreDefinedIndex";
import { useStandard } from "../../../../context/StandardContext";
import useGetStandardDetail from "../../../../hooks/useGetStandardDetail";
import { useLocation, useParams } from "react-router-dom";
import useFetchPreReport from "../../../../hooks/useFetchPreReport";
import NuDateFormat from "../../../../utils/NuDate";
import { CloseIcon, PaperClip } from "../../../../assets/icons";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../../utils/OtherFunctions";
import { NuDate } from "../../../../utils/Inputs";
import FormikSelectTwo from "../../../../utils/Select";
import { CancelButton, SubmitButton } from "../../../../utils/Button";
import useGetStatusData from "../../../../hooks/useGetStatusData";
import DecryptData from "../../../../utils/Decrypt";
import useGetCompanyInfo from "../../../../hooks/useGetCompanyInfo";
import PDFGenerationScreen from "../../PDFGenerationScreen";

function MRMReport() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  let location = useLocation();

  console.log("ssslocation",location.state);
  
  const [value, setValue] = useState({
    standard_id: stdId,
    module_id: 18,
    type: location.state?.reportValue?.reset_count || 0,
    status_name: "",
    from_date:"",
    to_date:"",
  });

  const [params, setParams] = useState({
    standard_id: stdId,
    module_id: 18,
    type: location.state?.reportValue?.reset_count || 0,
    status_name: "",
    from_date: "",
    to_date:"",
    completion_start_date: "",
    completion_end_date: "",
    reminder_start_date: "",
    reminder_end_date: "",
  });

  const { statusValue } = useGetStatusData({ value: 12 });
  const [filter, setFilter] = useState(false);
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const { data, isLoading, review, getAllData, status } = useFetchPreReport({
    url: `/report/`,
    value: filter==true?params:value,
    hasFilter: filter,
  });
  const [showFiter, setShowFilter] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: params,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      console.log();
      setParams(value);
      setFilter(true)
      setTimeout(() => {
        setShowFilter(false);
      }, 600);
    },
  });

  function handleOnClose() {
    setShowFilter(false);
    formik.resetForm();
    setParams(value)
    setFilter(false)
  }

  const [pdfUrl, setPdfUrl] = useState(null);
  const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];
  const {company}=useGetCompanyInfo()
  const [isDataLoading,setIsDataLoading]=useState(true)
  useEffect(() => {
    const worker = new Worker(new URL('./mrmPDFWorker.jsx', import.meta.url));
    
    if(data.length>0){
      worker.onmessage = (e) => {
        setPdfUrl(e.data);
        setIsDataLoading(false);
      };
    }

    if (data.length > 0) {
      worker.postMessage({
        data,
        company:company,
        standardDetailName,
        review,
        standardStartDate,
        standardEndDate,
        Name: `CISO / MRM Meeting Report`,
        UserName: userData?.user_name,
        Location: userData?.location || "-",
        Country: userData?.country || "-",
        department: userData?.department || "-",
        header,
        status
      });
    }

   return () => {
      setIsDataLoading(false);
      worker.terminate();
    }
  }, [data,company,standardDetailName]);

  return (
    <>
      <ViewPreDefinedIndex
        label="CISO / MRM Meeting Report"
        standardName={standardName}
        menu="Report"
        header={header}
        isLoading={isLoading}
        review={review}
        hasFilter={filter}
        removeFilter={handleOnClose}
        dataView={data}
        startDate={standardStartDate}
        endDate={standardEndDate}
        setShowFilter={() => setShowFilter(true)}
        pdfUrl={pdfUrl}
        downloadFileName={`${standardName}-CISO / MRM Meeting Report Report ${
          standardStartDate &&
          NuDateFormat({
            value: standardStartDate,
            format: "MMM-YYYY",
          })
        } ${
          (standardEndDate ||
            standardEndDate) &&
          "to"
        } ${
          (standardEndDate ||
            standardEndDate) &&
          NuDateFormat({
            value:
            standardEndDate ||
            standardEndDate,
            format: "MMM-YYYY",
          })
        }.pdf`}

      />
      {showFiter && (
        <>
          <div
            id="modal"
            className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
    flex justify-center items-center "
          >
            <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
              <div className="flex items-start justify-between px-5 py-2  rounded-t">
                <h3 className="text-base 2xl:text-lg font-semibold">Filter</h3>
                <span
                  className="h-6 w-6 text-2xl block cursor-pointer"
                  onClick={handleOnClose}
                >
                  <CloseIcon />
                </span>
              </div>
              <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                <div className=" w-full  max-h-[70vh] overflow-y-auto relative px-6 flex flex-wrap justify-between">
                  <FormikSelectTwo
                    formik={formik}
                    name="status_name"
                    label="Status"
                    width="w-full"
                    placeholder="Select Status"
                    Options={statusValue}
                    zindex={12}
                  />
                </div>
                <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                  <CancelButton onClose={handleOnClose} />
                  <SubmitButton />
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    <PDFGenerationScreen visible={isDataLoading} activity={"CISO / MRM Meeting  Report"} format={"pdf"} name={standardName}/>
    </>
  );
}

export default MRMReport;

const header = [
  {
    label: "Sl.No",
    width: "w-[7%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "serial_number",
    headone: "Sl No.",
    type: "text",
    pdfWidth: "7%",
    textAlign: "center",
  },
  {
    label: "Heading",
    width: "w-[18%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "heading",
    type: "text",
    headone: "Heading",
    pdfWidth: "18%",
    textAlign: "center",
  },
  {
    label: "Group",
    width: "w-[15%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "group_data",
    type: "text",
    headone: "Group",
    pdfWidth: "15%",
    textAlign: "center",
  },
  {
    label: "Date",
    width: "w-[10%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "mom_date",
    type: "date",
    headone: "Date",
    pdfWidth: "10%",
    textAlign: "center",
  },
  {
    label: "Type of Meeting",
    width: "w-[20%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "type_of_meeting",
    type: "text",
    headone: "Type of Meeting",
    pdfWidth: "20%",
    textAlign: "center",
  },
  {
    label: "Status",
    width: "w-[10%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "status",
    type: "text",
    headone: "Status",
    pdfWidth: "10%",
    textAlign: "center",
  },
  {
    label: "Last Updated by",
    width: "w-[10%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "last_modified_name",
    feildnametwo: "created_name",
    feildnamethree: "created_by_name",
    type: "text",
    headone: "Last Updated by",
    pdfWidth: "10%",
    textAlign: "center",
  },
  {
    label: "Artefact",
    width: "w-[10%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "attachment",
    type: "file",
    headone: "Artefact",
    pdfWidth: "10%",
    textAlign: "center",
  },
];